import { Routes } from '@angular/router';
import { passwordRecoveryHashGuard } from './states/recovery/guards/password-recovery-hash.guard';

export const routes: Routes = [
  {
    path: 'authorization',
    loadChildren: () => import('./areas/unauthenticated/authorization/authorization.routes').then((file) => file.routes),
  },
  {
    path: 'registration',
    loadChildren: () => import('./areas/unauthenticated/registration/registration.routes').then((file) => file.routes)
  },
  {
    path: 'refresh',
    loadChildren: () => import('./areas/unauthenticated/refresh/refresh.routes').then((file) => file.routes),
  },
  {
    path: 'logout',
    loadComponent: () => import('./areas/unauthenticated/logout/logout.component').then((file) => file.LogoutComponent),
  },
  {
    path: 'password-recovery',
    pathMatch: 'full',
    canActivate: [passwordRecoveryHashGuard()],
    children: [],
  },
  {
    path: 'modal',
    outlet: 'modal',
    loadChildren: () => import('./areas/modals/modals.routes').then((file) => file.routes),
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: 'authorization',
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'authorization',
  },
];
